var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3604_24510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 9.50531C10.627 9.50531 12.7567 7.45049 12.7567 4.91574C12.7567 2.38099 10.627 0.326172 7.99992 0.326172C5.37284 0.326172 3.24316 2.38099 3.24316 4.91574C3.24316 7.45049 5.37284 9.50531 7.99992 9.50531Z",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9704 5.20609H7.90576V3.34668",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49114 15.664C3.68008 15.664 4.6439 14.734 4.6439 13.5869C4.6439 12.4397 3.68008 11.5098 2.49114 11.5098C1.3022 11.5098 0.338379 12.4397 0.338379 13.5869C0.338379 14.734 1.3022 15.664 2.49114 15.664Z",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 15.664C9.18887 15.664 10.1527 14.734 10.1527 13.5869C10.1527 12.4397 9.18887 11.5098 7.99993 11.5098C6.81099 11.5098 5.84717 12.4397 5.84717 13.5869C5.84717 14.734 6.81099 15.664 7.99993 15.664Z",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5087 15.664C14.6977 15.664 15.6615 14.734 15.6615 13.5869C15.6615 12.4397 14.6977 11.5098 13.5087 11.5098C12.3198 11.5098 11.356 12.4397 11.356 13.5869C11.356 14.734 12.3198 15.664 13.5087 15.664Z",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64404 13.5869H5.84733",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3691 13.5869H11.5724",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3604_24510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.61640cbfce7281a750eb975c0b38b902.svg";
export { ForwardRef as ReactComponent };